/* rabet-phase3: auto-advancing mobile carousels for slider-component lists */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var INTERVAL = 3200;
  function setup(section) {
    var slider = section.querySelector('ul.slider');
    if (!slider) return;
    var timer = null, paused = false, visible = false;
    function items() { return Array.prototype.filter.call(slider.children, function (li) { return li.clientWidth > 0; }); }
    function step() {
      if (paused || !visible || window.innerWidth >= 750) return;
      var list = items(); if (list.length < 2) return;
      var rtl = getComputedStyle(slider).direction === 'rtl';
      var pos = Math.abs(slider.scrollLeft), w = list[1].offsetLeft - list[0].offsetLeft; if (!w) return;
      var idx = Math.round(pos / Math.abs(w)), next = idx + 1;
      var max = list.length - Math.max(1, Math.floor(slider.clientWidth / Math.abs(w)));
      if (next > max) next = 0;
      var target = next * Math.abs(w);
      slider.scrollTo({ left: rtl ? -target : target, behavior: 'smooth' });
    }
    function start() { if (!timer) timer = setInterval(step, INTERVAL); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    ['touchstart', 'pointerdown', 'mouseenter'].forEach(function (e) { slider.addEventListener(e, function () { paused = true; }, { passive: true }); });
    ['touchend', 'pointerup', 'mouseleave'].forEach(function (e) { slider.addEventListener(e, function () { setTimeout(function () { paused = false; }, 4000); }, { passive: true }); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; visible ? start() : stop(); }, { threshold: 0.3 }).observe(section);
    } else { visible = true; start(); }
  }
  function init() { document.querySelectorAll("[id$='__why'], [id$='__reviews']").forEach(setup); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
